import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-followup-questions-footer',
  templateUrl: './followup-questions-footer.component.html',
  styleUrls: ['./followup-questions-footer.component.scss'],
  standalone: false,
})
export class FollowupQuestionsFooterComponent implements OnChanges {
  @Input() followupQuestions: string[] = [];
  @Output() questionSelected = new EventEmitter<string>();

  isExpanded = false;
  hasAutoExpanded = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['followupQuestions']) {
      this.updateExpansionState();
    }
  }

  private updateExpansionState() {
    // Auto-expand once when questions first become available
    if (this.followupQuestions.length > 0 && !this.hasAutoExpanded) {
      this.isExpanded = true;
      this.hasAutoExpanded = true;
    }

    // If questions are cleared, reset the auto-expand flag
    if (this.followupQuestions.length === 0) {
      this.hasAutoExpanded = false;
      this.isExpanded = false;
    }
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  collapse() {
    this.isExpanded = false;
  }

  onQuestionClick(question: string) {
    this.questionSelected.emit(question);
  }
}
